import { Helmet } from 'react-helmet-async';

import Button from '../../Components/Button';
import ComingSoon from '../../Components/Errors/Comingsoon';
import Footer from '../../Components/Footer';
import MediaBrowser from '../../Components/Main pages/Media';
import Navbar from '../../Components/Navbar';
import SearchSidebar from '../../Components/Search bars/Treesearch';
import Landingpage from '../Home/Landingpage';

import styles from './Audiopage.module.css';

export default function Audio() {
  const siteUrl = 'https://nasrollah.info';
  const pageUrl = `${siteUrl}/audios`;

  const siteName = 'nasrollah.info';

  const pageTitle = `روایت‌های شنیدنی و فایل‌های صوتی | ${siteName}`;

  const pageDescription =
    'شنیدن و مشاهده مجموعه‌ای از روایت‌های شنیدنی، فایل‌های صوتی و محتوای صوتی منتشرشد.';

  const pageImage = `${siteUrl}/assets/images/og-audio.jpg`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name: pageTitle,
        description: pageDescription,
        inLanguage: 'fa-IR',
        isPartOf: {
          '@type': 'WebSite',
          '@id': `${siteUrl}#website`,
          url: siteUrl,
          name: siteName,
          inLanguage: 'fa-IR',
        },
        breadcrumb: {
          '@id': `${pageUrl}#breadcrumb`,
        },
      },
      {
        '@type': 'CollectionPage',
        '@id': `${pageUrl}#collection`,
        url: pageUrl,
        name: 'روایت‌های شنیدنی',
        description: pageDescription,
        inLanguage: 'fa-IR',
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${pageUrl}#breadcrumb`,
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'صفحه اصلی',
            item: siteUrl,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'صوت',
            item: pageUrl,
          },
        ],
      },
    ],
  };

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>{pageTitle}</title>

        <meta name="description" content={pageDescription} />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />

        <meta httpEquiv="content-language" content="fa-IR" />
        <meta name="author" content={siteName} />

        {/* Canonical URL */}
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:site_name" content={siteName} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={pageImage} />
        <meta
          property="og:image:alt"
          content="روایت‌های شنیدنی و محتوای صوتی"
        />

        {/* Twitter / X */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={pageImage} />

        {/* Structured data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
    <Navbar />
    <Landingpage />

    <div className={styles.main}>
        <div className={styles.container}>
            <div className={styles.section}>
  <span className={styles.sectionSubtitle}>
    'روایت‌های شنیدنی'
  </span>
  <h1 className={styles.sectionTitle}>
    'صوت'
  </h1>
</div>
            <p className={styles.para}>در این بخش، مجموعه‌ای از سخنرانی‌های شهيد سيد حسن نصرلله به صورت صوتی گردآوری و در دسترس شما قرار گرفته است. این مجموعه شامل فایل‌های صوتی کامل از بیانات ایشان است که در حوزه‌های متنوعی همچون سیاست، دین، عرفان و مباحث اندیشه‌ای ایراد شده و بخش مهمی از میراث فکری ایشان را تشکیل می‌دهد. شنیدن این صوت‌ها، امکان همراهی با لحن، بیان و حال و هوای اصلی سخنرانی‌ها را برای مخاطب فراهم می‌سازد و دریچه‌ای به سوی اندیشه‌ها و دغدغه‌های ایشان در طول سالیان متمادی فعالیتشان می‌گشاید.</p>
            <Button />
        </div>
    </div>
    
      <div className={styles.container} >
        <div className={styles.bodyContent}>
            <SearchSidebar />

            <MediaBrowser />
        </div>
    </div>

    <Footer />
    </>);
}